import { Route, Switch } from 'react-router-dom';

import About from './pages/about';
import urls, { aboutUrl } from './urls';


const AboutRoute = () => {
  return (
    <Switch>
      <Route exact path={aboutUrl()} component={About} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default AboutRoute;
